const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi43MDcgMS4yOTNsMjAgMjAtMS40MTQgMS40MTRMMTEuNTg2IDEzSDd2LTJoMi41ODZsLTItMkg2YTMgMyAwIDAgMCAwIDZoNHYySDZhNSA1IDAgMCAxLS4zOTktOS45ODRMMS4yOTMgMi43MDdsMS40MTQtMS40MTR6TTE4IDdhNSA1IDAgMCAxIDIuNTI5IDkuMzE0bC0xLjQ5Ny0xLjQ5NkEzLjAwMSAzLjAwMSAwIDAgMCAxOCA5aC00VjdoNHoiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  M as default
};
//# sourceMappingURL=unlink-6bab1a78.mjs.map
